import { useMutation, useQueryClient } from '@tanstack/react-query'
import bankTransactionService from '../services'
import { TransactionQueryKeys } from '../../keys'
import { SmsAutoLogStatus } from '@/modules/transaction/types'
import showErrorToast from '@/common/utils/showErrorToast'

export function useMutationUpdateSmsAutoLogStatus() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ id, status }: { id: string; status: SmsAutoLogStatus }) =>
			bankTransactionService.updateSmsAutoLogStatus(id, { status }),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TransactionQueryKeys.SMS_AUTO_LOGS],
			})
		},
		onError: (error) => showErrorToast(error),
	})
}
